<div class="info-box">
    <div>
        <mat-icon class="navigation-icon" (click)="carousel.pre()">chevron_left</mat-icon>
    </div>
    <nz-carousel #carousel [nzDots]="false">
        <div nz-carousel-content *ngFor="let info of infoList" class="info-container" [class]="info.Type">
            <div class="info-icon">
                <img [src]="'assets/images/dashboard/' + info.Type + '.svg'"/>
            </div>
            <div class="info-details">
                <div class="info-title"><span>{{info.title}}</span></div>
                <div class="info-content"><span>{{info.content}}</span></div>
                <div class="info-footer">
                    <div class="info-date">
                        <i class="fa fa-calendar-o info-date-icon"></i>
                        <span>{{info.lastUpdated}}</span>
                    </div>
                    <div class="discover-more"><a [href]="info.url" target="_blank">Discover More</a></div>
                </div>
            </div>
            <img class="info-background-image" draggable="false" src="assets/images/dashboard/info-box.svg"/>
        </div>
    </nz-carousel>
    <div>
        <mat-icon class="navigation-icon" (click)="carousel.next()">chevron_right</mat-icon>
    </div>
</div>
